// extracted by mini-css-extract-plugin
export default {"headerHeight":"3.75rem"};